import { useState, useEffect } from "react";
import { ConnectForm } from "../common/ConnectForm";
import { Link } from "react-router-dom";
import heroImage from "../../assets/hero1.webp";

const cities = ["Noida", "Udaipur", "Ajmer", "Pushkar", "Mumbai", "Himachal Pradesh", "Uttrakhand", "Indore", "Jaisalmer", "Agra", "Mathura", "Jodhpur"];

export default function Hero() {
    const [cityIndex, setCityIndex] = useState(0);


    useEffect(() => {
        const interval = setInterval(() => {
            setCityIndex((prevIndex) => (prevIndex + 1) % cities.length);
        }, 2000)
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="relative w-full min-h-screen">
            <section className="relative h-screen w-full flex flex-col">
                {/* Background Image */}
                <img
                    src={heroImage}
                    alt="Hero"
                    loading="eager"
                    fetchPriority="high"
                    decoding="async"
                    className="absolute inset-0 w-full h-full object-cover"
                />


                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>

                {/* Content */}
                <div className="relative z-10 flex flex-col md:flex-row items-center justify-between min-h-screen text-white px-4 sm:px-10 md:px-20 pt-20">
                    {/* Left Section - Heading & Button */}
                    <div className="relative flex flex-col items-center md:items-start justify-center text-center md:text-left w-full md:w-1/2">
                        <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold w-full">
                            Book Cab from Jaipur to{" "}
                            <span className="text-pink-400 transition-all duration-500">
                                {cities[cityIndex]}
                            </span>
                        </h1>

                        <p className="text-base sm:text-lg md:text-xl mt-4 max-w-2xl">
                            Ride with Comfort, Travel with Trust
                        </p>
                        <Link
                            to="/packages"
                            className="mt-4 inline-block px-4 py-2 sm:px-6 sm:py-3 bg-none text-white font-semibold rounded-lg shadow-lg border-2 border-pink-600 hover:bg-pink-600 transition"
                        >
                            Explore
                        </Link>
                    </div>

                    <div className="md:w-1/3">
                        <ConnectForm />
                    </div>
                </div>
            </section>
        </div>
    )
}
